import axios from 'axios';

/** 인증 헤더 없이 캐시 가능한 홈 공개 읽기 모델을 조회한다. */
export async function fetchPublicHomeFeed({ pageSize = 10, cursor = null, kind = 'default' } = {}) {
  const params = { pageSize, kind };
  if (cursor) params.cursor = cursor;
  const response = await axios.get('/api/home-feed', { params, skipAuth: true });
  return response.data?.data;
}

/** 공개 피드 렌더링과 분리된 사용자별 좋아요 상태를 한 번에 조회한다. */
export async function fetchHomeFeedLikes(postIds) {
  const ids = [...new Set((postIds || []).filter((id) => Number.isInteger(id) && id > 0))];
  if (ids.length === 0) return {};
  const response = await axios.get('/api/home-feed/likes', {
    params: { ids: ids.join(',') },
  });
  return response.data?.likes || {};
}
